import React, { useState, useEffect } from 'react';

import { apiPut, apiGet, getAccountsApiUrl, apiMessages,} from '../common/AppApi';
import { patternMessage, invalidInputStyle, selectOptions } from '../common/Forms';
import { cleanPhone, formatPhone, decodeValues } from '../common/Formats';
import Strings from  '../common/Strings';

export default function ChangeAgency(props) {
	let [moveForm, setMoveForm] = useState({fromAgency:'', toAgency:''});
	let [showSpinner, setSpinner] = useState(false);
	let [message, setMessage] = useState();

	let divStyle = {
		width:'45rem', height:'35rem',
		margin: 'auto',
		position: 'fixed',
		top: 0, left: 0, bottom: 0, right: 0,
		zIndex: 100,
	};

	let moveRecipient = (e) => {
		e.preventDefault();
		setSpinner(true);

		let body = {...moveForm};
		body.accountUuid = props.accountUuid;
		body.fromAgency = props.agencyUuid;

		//console.log(body);
		let url = getAccountsApiUrl() + '/account/move'
		apiPut(url, body).then((resp) => {
			if (props.successFunction)
				props.successFunction();
		}).catch( (err) => {
			console.error(err);
			if (err.status == 404) {
				setMessage("You must have access to both agencies to move the recipient.");
			} else if (err.data.errors && err.data.errors.length) {
				setMessage(err.data.errors[0].defaultMessage);
			} else if (err.data.errorMessages && err.data.errorMessages.length) {
				setMessage(err.data.errorMessages[0].appErrorMessage);
			} else if (err.data.message) {
				setMessage(err.data.message);
			} else if (err.statusText) {
				setMessage(err.statusText);
			}
		}).finally(() => setSpinner(false));
	};

	let DisplayMessage = () => {
		if (message) {
			return (
				<div className='alert alert-danger'>{message}</div>
			);
		} else {
			return (<div className="alert">&nbsp;</div>);
		}
	};

	let handleFieldChange = (event) => {
		const {id, value} = event.target;
		let cloned = {...moveForm, [id]:value};
		setMoveForm(cloned);
	}

	let disableButton = () => {
		if (moveForm.toAgency || props.agencyUuid)  {
			return (moveForm.toAgency == props.agencyUuid);
		} else {
			return true;
		}
	};

	let closeMe = () => {
		setMessage('');
		props.closeFunction();
	};

	if (props.show) {
		return <div style={divStyle} id="moveRecipient">
			<div className="card border-primary m-0">
				<div className="card-body">
					<DisplayMessage/>

				<form onSubmit={moveRecipient}>
					<div className="row">
						<div className="form-group col-12 col-sm-5">
							<label className="asterisk-label">Current Agency</label>
							<br/>
							{props.agencyName}
						</div>
						<div className="form-group col-12 col-sm-5">
							<label className="asterisk-label" htmlFor="toAgency">Move To</label>
							<select id="toAgency" className="form-control custom-select" value={moveForm.toAgency} onChange={handleFieldChange}>
								{ selectOptions(props.agencies) }
							</select>
						</div>

						<div className="form-group col-12">
						<button className="btn btn-primary" id="btnMove" disabled={disableButton()}>Move</button>
						<button className="btn btn-primary ml-1" type="button" onClick={closeMe}>Cancel</button>
						</div>

						<div className="form-group col-12">
							<div className="form-check">
								<label className='form-check-label' htmlFor="iAgree" style={{padding:'.1em'}}>
								<input className="form-check-input" type="checkbox" value="true" id="iAgree" required />
								Yes, I really want to move the recipient.
								</label>
							</div>
						</div>
					</div>

				</form>

				</div>
			</div>
		</div>;
	}

	return null;
}
